export { LatestMonthlyReportsWidget } from './LatestMonthlyReports';
